import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Host,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Optional,
  Output,
  Renderer2,
  SkipSelf,
  ViewChild,
} from "@angular/core";
import {
  AbstractControl,
  ControlContainer,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { BaseControlValueAccessor } from "app/components/molecules/input-form/utils/base-control-value-accessor";
import { BehaviorSubject } from "rxjs";

@Component({
  selector: "app-input-form",
  templateUrl: "./input-form.component.html",
  styleUrls: ["./input-form.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFormComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class InputFormComponent
  extends BaseControlValueAccessor<any>
  implements OnInit
{
  @Input() loading$ = new BehaviorSubject<boolean>(false);
  @Input() type: "text" | "password" | "number" = "text";
  @Input() classNameInput: string = "";
  @Input() classNameLabel: string = "";
  @Input() classNameInputForm: string = "";
  @Input() label: string;
  @Input() submit: boolean = false;
  @Input() required: boolean = false;
  @Input() formControlName: string;
  @Input() placeholder: string = "";
  @HostBinding("attr.formControlName") customDirective: any;
  @ViewChild("elementRef", { static: true }) public elementRef: ElementRef;
  @Output() changed = new EventEmitter<any>();
  control: AbstractControl;

  constructor(
    @Optional() @Host() @SkipSelf() private controlContainer: ControlContainer,
    private renderer2: Renderer2
  ) {
    super();
  }

  @HostListener("input", ["$event.target.value"])
  onInput(value: any) {
    let newValue = value;
    this.onChange(newValue);
    Promise.resolve().then(() => {
      this.changed.emit(newValue);
    });
  }

  ngOnInit(): void {
    if (this.controlContainer && this.formControlName) {
      const control = this.controlContainer?.control?.get(this.formControlName);
      if (control) {
        this.control = control;
        const validator = this.control.validator;
        if (validator) {
          const validationResult = validator(this.control);
          if (validationResult && validationResult.required) {
            this.required = true;
          }
        }
      }
    }
  }

  override writeValue(value: string | number): void {
    if (this.renderer2 && value) {
      this.renderer2.setProperty(
        this.elementRef?.nativeElement,
        "value",
        value
      );
    }
  }

  override setDisabledState(disabled: boolean): void {
    if (disabled) {
      this.disabled = disabled;
      this.renderer2.setAttribute(
        this.elementRef.nativeElement,
        "disabled",
        String(!disabled)
      );
    } else {
      this.renderer2.removeAttribute(this.elementRef.nativeElement, "disabled");
    }
  }
}
